import React, { useEffect, useState } from "react";

function ScrollTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <a
      id="scroll-top"
      style={{ display: visible ? "block" : "none" }}
      onClick={scrollToTop}
    >
      <i className="far fa-arrow-up"></i>
    </a>
  );
}

export default ScrollTop;
